import { Component } from '@angular/core';
import { Localization } from '../../shared/enums/localization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-account-created',
  templateUrl: './account-created.component.html',
  styleUrls: ['./account-created.component.scss']
})
export class AccountCreatedComponent {

  public readonly Localization = Localization;

  constructor() { }

  public goToAccountPage() {
    const redirectUrl = window.location.protocol + '//' + window.location.host;
    window.location.href = environment.accountSiteUrl + 'login?redirectUrl=' + redirectUrl;
  }
}
